import { create } from 'zustand'

interface ThemeState {
  isDark: boolean
  toggle: () => void
  setDark: (value: boolean) => void
}

export const useThemeStore = create<ThemeState>((set) => ({
  isDark: localStorage.getItem('theme') === 'dark' || 
    (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches),
  toggle: () => set((state) => {
    const newValue = !state.isDark
    localStorage.setItem('theme', newValue ? 'dark' : 'light')
    document.documentElement.classList.toggle('dark', newValue)
    return { isDark: newValue }
  }),
  setDark: (value: boolean) => {
    localStorage.setItem('theme', value ? 'dark' : 'light')
    document.documentElement.classList.toggle('dark', value)
    set({ isDark: value })
  }
}))
